import { setLocalStorage, getLocalStorage, removeLocalStorage, localStorageSupported } from './localStorageHelpers'

export const setSetting = (key, value) => {
    if (localStorageSupported)
        setLocalStorage(key, value)
}

export const getSetting = (key) => {
    if (localStorageSupported)
        return getLocalStorage(key)

    return null
}

export const removeSetting = (key) => {
    if (localStorageSupported)
        removeLocalStorage(key)
}
